import { cva } from "class-variance-authority";

export { default as FilterBadge } from "./FilterBadge.vue";
export { default as PriorityBadge } from "./PriorityBadge.vue";
export { default as StatusBadge } from "./StatusBadge.vue";

export const priorityVariants = cva(
    "inline-flex items-center gap-1.5 font-medium rounded-sm transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            priority: {
                high: "text-utility-error-700 bg-utility-error-50",
                normal: "text-utility-warning-700 bg-utility-warning-50",
                low: "text-utility-gray-700 bg-utility-gray-light-100",
            },
            size: {
                small: "text-xs px-1.5 py-0.5 px-2 py-px h-6",
            },
        },
        defaultVariants: {
            size: "small",
        },
    }
);

export const statusVariants = cva("gap-1 [&_#icon]:w-3 [&_#icon]:h-3", {
    variants: {
        status: {
            open: "text-utility-gray-700 bg-utility-gray-50 border-utility-gray-200 [&_#icon]:text-utility-gray-500",
            scheduled:
                "text-utility-blue-700 bg-utility-blue-50 border-utility-blue-200 [&_#icon]:text-utility-blue-500",
            completed:
                "text-utility-success-700 bg-utility-success-50 border-utility-success-200 [&_#icon]:text-utility-success-500",
            deleted:
                "text-utility-error-500 bg-utility-error-50 border-utility-error-200 [&_#icon]:text-utility-error-500",
        },
    },
    defaultVariants: {
        status: "open",
    },
});
